export default "__VITE_ASSET__BMBmlb2F__"